import image1 from "../../components/Student_Achievement/image1.jpg";
import image2 from "../../components/Student_Achievement/image2.jpg";
import image3 from "../../components/Student_Achievement/image3.jpg";
import image4 from "../../components/Student_Achievement/image4.jpg";
import image5 from "../../components/Student_Achievement/image5.jpg";
import image6 from "../../components/Student_Achievement/image6.jpg";
import image7 from "../../components/Student_Achievement/image7.jpg";
import image8 from "../../components/Student_Achievement/image8.jpg";
import image9 from "../../components/Student_Achievement/image9.jpg";
import image10 from "../../components/Student_Achievement/image10.jpg";
import image11 from "../../components/Student_Achievement/image11.jpg";
import image12 from "../../components/Student_Achievement/image12.jpg";
import image13 from "../../components/Student_Achievement/image13.jpg";
import image14 from "../../components/Student_Achievement/image14.jpg";
import image15 from "../../components/Student_Achievement/image15.jpg";
import image16 from "../../components/Student_Achievement/image16.jpg";
import image17 from "../../components/Student_Achievement/image17.jpg";
import image18 from "../../components/Student_Achievement/image18.jpg";

export const IMAGES = [
  { src: image1, thumbnail: "" },
  { src: image2, thumbnail: "" },
  { src: image3, thumbnail: "" },
  { src: image4, thumbnail: "" },
  { src: image5, thumbnail: "" },
  { src: image6, thumbnail: "" },
  { src: image7, thumbnail: "" },
  { src: image8, thumbnail: "" },
  { src: image9, thumbnail: "" },
  { src: image10, thumbnail: "" },
  { src: image11, thumbnail: "" },
  { src: image12, thumbnail: "" },
  { src: image13, thumbnail: "" },
  { src: image14, thumbnail: "" },
  { src: image15, thumbnail: "" },
  { src: image16, thumbnail: "" },
  { src: image17, thumbnail: "" },
  { src: image18, thumbnail: "" },
];

